  <template>
    <section class="section-wrapper portfolio-section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="section-title">
              <h2>Portfolio</h2>
            </div>
          </div>
        </div>
        <div class="row" >
          <!-- FOR DE TODO  -->
          <div class="col-md-6" v-for="(img, imgIdx) in imgs" :key="imgIdx">
            <a class="portfolio-item" v-bind:href="img.urlDestination" target= "_blank">
              <div class="portfolio-thumb">
                <img v-bind:src="'img/portfolio/' + img.urlImage" v-bind:alt="img.title" v-bind:title="img.title">
              </div>

              <div class="portfolio-info">
                <h3>{{img.title}}</h3>
                <small>{{img.description}}</small>
              </div>
              <!-- portfolio-info -->
            </a>
            <!-- .portfolio-item -->
          </div>

        </div>
        <!-- /.row -->
      </div>
    </section>
    <!-- .portfolio -->
  </template>
<style scoped>
.portfolio-thumb {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.portfolio-image {
  width: 100%;
  max-width: 900px;
  height: auto;
  max-height: 600px;
  object-fit: cover; /* Asegura que la imagen se ajuste correctamente sin deformarse */
}
</style>
<script>
import GLightbox from 'glightbox'

export default {
  components: {
    //VueEasyLightbox
  },

  data: function() {
    return {
      imgs: [
        {
          urlImage: 'telefonica.jpg',
          urlDestination: 'https://www.telefonica.com/es/home',
          title: 'Telefónica',
          description: 'Diagnostic and Monitoring Core Routers App'
        },
        {
          urlImage: 'seo.jpg',
          urlDestination: '',
          title: 'SEO',
          description: 'Amazing SEO results'
        },
        {
          urlImage: 'electronicsproyects.jpg',
          urlDestination: '',
          title: 'Electronics Proyects',
          description: 'IoT electronics Proyects'
        },
        {
          urlImage: 'greenpanda.jpg',
          urlDestination: '',
          title: 'Inmotic Software',
          description: 'Inmotic & Domotic Manegent Software'
        },
        {
          urlImage: 'roboticclass.jpg',
          urlDestination: '',
          title: 'Robotic Class',
          description: 'Teens and Kids Tech Class'
        },
        {
          urlImage: 'smartcity.jpg',
          urlDestination: '',
          title: 'Smart City Model',
          description: 'Telecontroling City Model'
        },
        {
          urlImage: 'iot.jpg',
          urlDestination: '',
          title: 'IoT Interaction',
          description: 'IoT projects, Raspberry Pi NodeJS & Python gateway to Arduino sensors.'
        },
        {
          urlImage: 'fabuilding.png',
          urlDestination: '',
          title: 'SmartCities and SmartBuildings Evangelist',
          description: 'Workshops were organized and a group was formed to promote innovation in smart cities and smart buildings.'
        },
        
        {
          urlImage: 'greenpandapromotion.jpg',
          urlDestination: '',
          title: 'Green Panda Promotion',
          description: 'Green Panda Platform Promotion in IFEMA (Madrid)'
        },
        {
          urlImage: 'latouche.jpg',
          urlDestination: '',
          title: 'Retro Machine Reform',
          description: 'Repair with Arduino a retro machin like a pinball'
        },
        {
          urlImage: 'techclass.jpg',
          urlDestination: '',
          title: 'Tech Class',
          description: 'Tech class as Alternative nightlife, León Town Hall'
        },
        {
          urlImage: '3dscan.jpg',
          urlDestination: '',
          title: '3D Scan',
          description: 'Kinnect 3d Scanning myselft'
        },
        {
          urlImage: 'scout.jpg',
          urlDestination: '',
          title: 'Scout Assistant',
          description: 'SelfDefense Class in a Scout Camp (volunteering)'
        },
        {
          urlImage: 'fablab.jpg',
          urlDestination: '',
          title: 'FabLab Voluntary',
          description: 'Helper of Fabers'
        },
        {
          urlImage: 'ecat.jpg',
          urlDestination: '',
          title: 'E-Cat',
          description: 'Control Engineer (PLC, SCADA & Eletrical)'
        },
        {
          urlImage: 'electrician.png',
          urlDestination: '',
          title: 'Electrician',
          description: 'Electrician'
        }

      ]
      }

  },
  mounted: function(){
    var lightbox = GLightbox();
  var lightboxDescription =GLightbox({
      selector: 'glightboxTest'
    })

    },
  methods: {
    show (index) {
      this.index = index
      this.visible = true
    }
  }
}

</script>
